import {Injectable} from "@angular/core";
import {ContactModel, contactModelFactory} from "./contact.model";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ModifyContactDialogComponent, ModifyContactDialogResultInterface} from "./modify-contact-dialog.component";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class ContactService {
  modifyContact(
    targetType: string,
    targetLevel: string,
    targetId: string,
  ): Promise<ModifyContactDialogResultInterface> {
    const model = {targetType, targetLevel, targetId, contactService: this as ContactService};
    return ModifyContactDialogComponent.showContactModal(this.dialogService, model);
  }

  getContact(params: {[key: string]: string}): Promise<ContactModel> {
    return this.http.get<{contact: ContactModel}>(`/api/contact`, {params})
      .pipe(map(({contact}) => contactModelFactory(contact)))
      .toPromise();
  }

  updateContact(params: {[key: string]: string}, contact: ContactModel): Promise<string> {
    return this.http.post<{message: string}>(`/api/contact`, {contact}, {params})
      .pipe(map(json => `${json["message"] || ""}`))
      .toPromise();
  }

  constructor(private dialogService: DialogService, private http: HttpClient) {}
}
